export default "__VITE_ASSET__238db935__"